import React, { useState, useEffect } from 'react';
import doctorSignatureService from '../../../services/doctorSignatureService';
import reportFormatService from '../../../services/reportFormatService';
import PathologyReportDocument from '../../../components/pathologyReport/PathologyReportDocument';
import { REPORT_FORMATS, DEFAULT_REPORT_FORMAT, isReportFormat } from '../../../components/pathologyReport/reportHelpers';

export const PathologyReportPreviewModal = ({
  isOpen,
  onClose,
  patient,
  tests = [],
  testObservationsMap = {},
  signatureProfile = null,
}) => {
  const [signatures, setSignatures] = useState([]);
  const [centre, setCentre] = useState(null);
  const [format, setFormat] = useState(DEFAULT_REPORT_FORMAT);

  useEffect(() => {
    if (isOpen) {
      doctorSignatureService.getAllProfiles().then(res => {
        if (res?.data) setSignatures(res.data);
      }).catch(() => {});
    }
  }, [isOpen]);

  // The layout is chosen per centre by an administrator; the bill's own centre decides which one is used.
  const billNo = patient?.ledgerTransactionNo;
  useEffect(() => {
    if (!isOpen || !billNo) return undefined;
    let cancelled = false;
    setCentre(null);
    setFormat(DEFAULT_REPORT_FORMAT);
    reportFormatService.getForBill(billNo).then((res) => {
      if (cancelled || !res?.data) return;
      setCentre(res.data);
      if (isReportFormat(res.data.formatCode)) setFormat(res.data.formatCode);
    }).catch(() => { /* keep the default layout and the centre name already on the bill */ });
    return () => { cancelled = true; };
  }, [isOpen, billNo]);

  if (!isOpen || !patient) return null;

  const handlePrint = () => {
    window.print();
  };

  const activeSignature = signatureProfile ||
    signatures.find(s => s.profileId === patient?.signatureProfileId || (tests[0] && s.profileId === tests[0]?.signatureProfileId)) ||
    signatures.find(s => s.employeeId === patient?.reportingDoctorId || (tests[0] && s.employeeId === tests[0]?.reportingDoctorId)) ||
    signatures.find(s => s.doctorName === patient?.reportingDoctorName || (tests[0] && s.doctorName === tests[0]?.reportingDoctorName)) ||
    (signatures.length > 0 ? signatures[0] : null);

  return (
    <div className="path-report-modal-backdrop" onClick={onClose}>
      <div className="path-report-modal-content" onClick={(e) => e.stopPropagation()}>
        {/* Top Control Bar (Hidden on Print) */}
        <div className="path-report-modal-header no-print">
          <div className="header-left">
            <span className="report-badge">Diagnostic Report Preview</span>
            <h3>{patient.patientName} — {patient.ledgerTransactionNo}</h3>
          </div>
          <div className="header-actions">
            <label className="path-report-format-pick">
              Layout
              <select aria-label="Report layout" value={format} onChange={(e) => setFormat(e.target.value)}>
                {REPORT_FORMATS.map((f) => <option key={f.code} value={f.code}>{f.name}</option>)}
              </select>
            </label>
            <button type="button" className="path-btn path-btn-primary" onClick={handlePrint}>
              🖨️ Print / Save as PDF
            </button>
            <button type="button" className="path-btn path-btn-secondary" onClick={onClose}>
              ✕ Close
            </button>
          </div>
        </div>

        {/* Printable A4 report in the centre's layout */}
        <div className="printable-report path-report-paper">
          <PathologyReportDocument
            format={format}
            centre={centre}
            patient={patient}
            tests={tests}
            testObservationsMap={testObservationsMap}
            signature={activeSignature}
            signatureUrl={activeSignature
              ? doctorSignatureService.getSignatureImageUrl(activeSignature.profileId, activeSignature.currentVersion)
              : null}
          />
        </div>
      </div>
    </div>
  );
};

export default PathologyReportPreviewModal;
